import { SET_QUESTIONS, SET_RESTORED_ANSWERS } from './questions.actions';

const initialState = {
  questions: {},
  restoredAnswers: {},
};

export const questionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_QUESTIONS:
      return {
        ...state,
        questions: payload,
      };
    case SET_RESTORED_ANSWERS:
      return {
        ...state,
        restoredAnswers: payload,
      };
    default:
      return state;
  }
};
